import type { RootState } from '../root_reducer';
import { BUILDOUT_CRM_MODE, RETHINK_MODE } from '../../embedded_mode';

export const selectDefaultMapType = (state: RootState): string => {
  return state.ui.profile?.defaultMapType || 'roadmap';
};

export const selectHasUnlimitedUnlocks = (state: RootState): boolean => Boolean(state.ui.profile?.hasUnlimitedUnlocks);

export const selectShowTableView = (state: RootState): boolean => state.ui.showTableView;

export const selectShowMap = (state: RootState): boolean => state.ui.showMap;

export const selectOffMarketSearch = (state: RootState): boolean => Boolean(state.ui.offMarketSearch);

export const selectCallListTableView = (state: RootState): boolean => state.ui.callListTableView;

export const selectLoading = (state: RootState): boolean => state.ui.loading;

export const selectStaticCallList = (state: RootState): boolean => Boolean(state.ui.staticCallList);

export const selectEmbeddedMode = (state: RootState): typeof RETHINK_MODE | typeof BUILDOUT_CRM_MODE | '' => {
  return state.ui.embeddedMode || '';
};
